// "Lúc xảy ra" của phiếu lỗi — hai ô NGÀY + GIỜ (CEO chốt 1a, 19/10/2026).
//
// Ô cũ là MỘT ô datetime-local. Chrome hiện nó "--:-- dd/mm/yyyy": người chọn
// ngày mà để trống giờ thì ô vẫn hiện ngày nhưng trả chuỗi RỖNG, phiếu đi không
// có ngày, máy chủ lấy ngày bấm lưu và gộp nhầm vào phiếu cùng người · cùng mã
// hôm đó (QĐ 0244). Tách hai ô để chỉ chọn ngày là đủ.
import { formatDate, formatDateTime } from "@/lib/format";

/**
 * Ghép hai ô thành mốc ISO có múi giờ để gửi máy chủ — hoặc `undefined` = để
 * máy chủ lấy lúc ghi phiếu.
 *
 * - Trống cả hai → lúc ghi phiếu.
 * - Chỉ có giờ → giờ đó của hôm nay.
 * - Chỉ có ngày HÔM NAY → lúc ghi phiếu (đúng ngày, giờ thật hơn 00:00).
 * - Chỉ có ngày khác → 00:00 ngày đó; `formatOccurredAt` hiện lại chỉ ngày.
 *
 * Giờ đọc theo giờ ĐỊA PHƯƠNG của trình duyệt rồi `toISOString()` gắn múi giờ.
 */
export function occurredAtFrom(day: string, time: string, today: string): string | undefined {
  if (!day && !time) return undefined;
  const d = day || today;
  if (!time && d === today) return undefined;
  const at = new Date(`${d}T${time || "00:00"}`);
  return Number.isNaN(at.getTime()) ? undefined : at.toISOString();
}

/** Mốc xảy ra để đọc: đúng 00:00 là phiếu chỉ chọn ngày — không bịa giờ. */
export function formatOccurredAt(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  return d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0
    ? formatDate(d)
    : formatDateTime(d);
}
